export default __webpack_public_path__ + "static/media/logo_otn_market_white@4x.cc3df8e9.png";